import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Pagination } from 'swiper/modules';
import '../styles/CustomSwiper.css';
import { colour } from '../styles/GlobalStyles';
import { Chevron } from '../assets/icons';

function CustomSwiper(props) {
	const images = props.images;
	const title = props.title;
	const imageLimit = props.imageLimit;
	const arrowClicked = props.arrowClicked;
	const imageClick = props.imageClick;
	const [elementHover, setElementHover] = useState(false);
	const [swiperInstance, setSwiperInstance] = useState(null);
	// Enable Swiper's loop mode only when there are enough slides (>= 3)
	const enableLoop = images && images.length >= 3;

	const showArrows = () => {
		if ( images === null ) {
			return;
		}
		else if ( images.length > 1 ) {
			setElementHover(true)
		}
	};

	const hideArrows = () => {
		setElementHover(false)
	};

	return (
		images !== undefined || swiperInstance !== null ?
			<div 
				className={"custom-swiper-module-container " + (elementHover === true ? "custom-swiper-module-container-hover" : "")}
				onMouseEnter={() => showArrows()}
				onMouseLeave={() => hideArrows()}
			>
				<Swiper 
					pagination={{
						dynamicBullets: true,
					}}
					onSwiper={(swiper) => {
						setSwiperInstance(swiper);
					}}
					modules={[Pagination, Navigation]} 
					className="custom-swiper-outer-container"
					loop={enableLoop}
					// slidesPerView={5}
					navigation={{
						prevEl: '.swiper-button-prev',
						nextEl: '.swiper-button-next',
					}}
				>
					<div className="swiper-button-prev" onClick={(e) => arrowClicked === null ? null : arrowClicked(e)}>
						<Chevron
							className="custom-swiper-icon"
							fill={colour.gray07}
						/>
					</div>
      				<div className="swiper-button-next" onClick={(e) => arrowClicked === null ? null : arrowClicked(e)}>
						<Chevron
							className="custom-swiper-icon"
							fill={colour.gray07}
						/>
					</div>
					{
						images === null || images.length === 0 ?
						<div className="custom-swiper-image-container">

						</div>
						:
						images.map((item, index) =>
							item.includes("maps.googleapis.com") === true ?
							null
							:
							(index + 1) <= imageLimit &&
							<SwiperSlide
								key={index}
							>
								<div 
									className="custom-swiper-image-container"
									onClick={imageClick === null ? null : () => imageClick()}
								>
									<img
										src={item}
										className="custom-swiper-image"
										alt={title}
									/>
								</div>
							</SwiperSlide>
						)
					}
				</Swiper>
			</div>
		:
		null
	)
}

export default CustomSwiper;